import gql from 'graphql-tag';
import { Field } from '../types';

interface UserSubscriptionVariables {
  fieldUuids: Array<Field['uuid']>;
  legacyUserId?: number; // pass the Legacy User Id of the user being proxied if proxying
}

export const getUserSubscriptionQuery = (variables: UserSubscriptionVariables) => ({
  query: gql`
    query UserSubscription($fieldUuids: [String!]!, $legacyUserId: Int) {
      userSubscription {
        name
        featuresByUserCountry(legacyUserId: $legacyUserId)
        featuresByFields(fieldUuids: $fieldUuids, legacyUserId: $legacyUserId) {
          features
          fieldId
        }
      }
    }
  `,
  variables,
});
